module.exports = __webpack_public_path__ + "static/media/introVideo.b687b06d.mp4";